function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            // Check for Safari
            if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                $(".filter-menu").addClass("is-safari");
            }
          
            // Accordion
            
              
              $('.filter-menu .filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').toggleClass('pt-group-expanded');
              
              if ($('.filter-group').hasClass('pt-group-expanded')) {
                $('.filter-group.pt-group-expanded h4').attr('aria-expanded', 'true');
              } else {
                $('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').find('h4').attr('aria-expanded', 'false');
              }
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            $('.pt-display-dropdown').each(function( index ) {
                $(this).find('h4').after($(this).find('.filter-clear'));
            });

            $('.pt-display-dropdown .scroll-content').each(function( index ) {
              if($(this).parent().find('.menu-trigger').length === 0) {
                if($(this).find('li.selected').length) {
                  var selected = $.map(
                    $(this).find('li.selected a'),
                    function(element){
                      return $(element).text();
                    }
                  ).join(", ");

                  if (selected.length < 30) {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + selected +'</div>');
                  } else {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + $(this).find('li.selected').length + ' Selected </div>');
                  }
                }
                else {
                  $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                }
              }
            });

            //Sticky Mode
             
              
                  $('.filter-menu').parent().addClass('pt-sticky-mode');
              

              

              
            

            // View more
            
            $('.filter-group ul:not(.has_selected)').each(function(){
              var max = 15;
              if ($(this).find("li:not(.selected)").length > (max+1)) {
                $(this).find('li:gt('+(max-1)+'):not(.selected)')
                .hide()
                .end()
                .append(
                  $('<li class="view-more-link"><a href="javascript:;">View More</a></li>').click( function(){
                      $(this).siblings(':hidden').slideDown(100).end().slideUp(100);
                  })
                );
              }
            });
            

            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested));
              })
            })

            // keep sort orders active
            if (window.location.search) {
                var querystr = window.location.search;
                var filterLinks = document.querySelectorAll('.filter-menu li a, .filter-menu .filter-clear');
                Array.prototype.forEach.call(filterLinks, function (a) {
                    if (a.search === "") {
                        a.search = querystr
                    }
                });
            }
          }

          pt_on_load();

          // Mobile filter button
          

          // Accordion
          
          $(document).on('click', '.filter-menu h4, .filter-menu .arrow-title', function(e){
            $(this).closest('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').toggleClass('pt-group-expanded');
            if ($(this).closest('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').hasClass('pt-group-expanded')) {
              $(this).closest('.filter-group h4').attr('aria-expanded', 'true');
            } else {
              $(this).closest('.filter-group h4').attr('aria-expanded', 'false');
            }
            /*if($(this).parents(".filter-group").hasClass("filter-group-sort-orders")){
              $(this).parents(".filter-group").find(".scroll-content").toggleSlide();
            }*/
            e.preventDefault();
          });
          
          $(document).on('keydown', '.filter-menu h4', function(e){
            if(e.which == 13 || e.which == 32) {
              e.preventDefault();
              $(this).click();
            }
          });
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger', function() {
            $(this).parents(".filter-group-sort-orders").find(".arrow-title").toggleClass("sort_by_active");
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
            $(this).next('.scroll-content').toggleClass('dropdown-open')
            if ($(this).next('.scroll-content').hasClass('dropdown-open')) {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection expanded');
            } else {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
            }
          });
          
          $(document).on('keydown', '.pt-display-dropdown .menu-trigger', function(e) {
            if(e.which == 13 || e.which == 32 ) { // return or space keys
              e.preventDefault();
              $(this).click();
            }
          });
          
          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).removeClass('dropdown-open');
            $(this).slideUp('fast');
            $(this).prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });
          
          $(document).on('focusout', '.pt-display-dropdown .scroll-content li:last-child', function() {
            $(this).closest('.scroll-content').removeClass('dropdown-open');
            $(this).closest('.scroll-content').slideUp('fast');
            $(this).closest('.scroll-content').prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });

          // Apply button
          
          $('.filter-menu').find(".button-group").append('<div class="filter-group"><button type="button" class="clear-filter-btn">Clear</button></div>');
          $('.filter-menu').find(".button-group").append('<div class="filter-group"><button type="button" class="pt-apply pt-apply-disabled">Apply</button></div>');
          $(document).on('click', '.pt-apply', function(e) {
            if ($('.filter-menu').data('current-url')) {
              window.location = $('.filter-menu').data('current-url');
            }
          });
          $(document).on('click', '.clear-filter-btn', function(e) {
            if(!$(this).hasClass("btn-disabled")){
              if ($('.collection-filter').data('url')) {
                window.location = $('.collection-filter').data('url');
              }
            }
          });
          $(document).on('click', '.filter-group li.collection-container a, .filter-group a.filter-clear', function(e) {
            if(!e.target.classList.contains('filter-clear')){
              e.preventDefault();
              e.stopPropagation();
            }
            var current_url = $(this).attr('href');
            $('.filter-menu').data('current-url', current_url).fadeTo('slow', 0.8);
            $.get(current_url, function( data ) {
              var elem = $(data).find('.filter-menu').first();
              $('.filter-menu').replaceWith(elem).fadeTo('fast', 1.0);
              $('.filter-menu').data('current-url', current_url).find(".button-group").append('<div class="filter-group"><button type="button" class="clear-filter-btn">Clear</button></div>');
              $('.filter-menu').data('current-url', current_url).find(".button-group").append('<div class="filter-group"><button type="button" class="pt-apply">Apply</button></div>');
              pt_on_load();
              $('.filter-menu .pt-mobile-header a').trigger('click');
            });
          });
          

          // Ajax
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();
